import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { User } from '../user/user';

@Injectable()
export class Invoice {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/project/invoice', params);
  }

  delete(params?: any) {
    return this.api.post('index.php/project/invoice/delete', params);
  }

  post(params?: any) {
    params.created_by = this.user.data.employee_id;
    return this.api.post('index.php/project/invoice', params);
  }

  category(params?: any) {
    return this.api.get('index.php/project/invoice/category', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/project_providers/invoice/invoice.ts